import { DEFAULT_FEEDBACK_URL } from '../common/config';
import { TYPE2CLASS } from '../core/icon-class';
import { ticksFormat } from '../common/datetime';

/*global gettext*/

let entityMap = {
  '&' : '&amp;',
  '<' : '&lt;',
  '>' : '&gt;',
  '"' : '&quot;',
  '\'': '&#39;',
  '/' : '&#x2F;',
};

let UserLogonEvents = {
  'UserLoggedOn'       : gettext('Вход в систему'),
  'UserLoggedOff'      : gettext('Выход из системы'),
  'UserSessionLocked'  : gettext('Сессия заблокирована'),
  'UserSessionUnlocked': gettext('Сессия разблокирована'),
};

let AppInstallationEvents = {
  'Install'  : gettext('Установка приложения'),
  'Deinstall': gettext('Удаление приложения'),
  'Inventory': gettext('Инвентаризация'),
};

function escapeHtml(string) {
  return String(string).replace(/[&<>"'\/]/g, function (s) {
    return entityMap[s];
  });
}

// Property widgets
let AttachedFileProperty = function (fact) {
  let eventName = fact['agent_eventtype.name'];
  if (eventName == 'Screenshot' || eventName == 'WebcamSnapshot' || fact['parentName'] == 'Screenshot') {
    return {
      key  : gettext('Cнимок экрана'),
      val  : '<img ng-src="/analytics/thumb/' + fact['agent_attachedfile.data'] +
      '" err-src="/static/img/default.png" ng-click="showImage(fact)" class="screenshot_thumb" />',
      class: 'important',
    };
  }

  if (eventName == 'SystemLog') {
    let file_name = 'Debug_'+escapeHtml(fact['agent_agent.computer_name'])+'.zip';
    return {
      key  : gettext('Контент'),
      val  : '<span class="attfilelink">' + gettext('Скачать') +
      ' <a href="/media/' + fact['agent_attachedfile.data'] +
      '" target="_blank" download="'+ file_name + '">' + file_name +
      ' <i class="icon icon-download"></i></a></span>',
      class: 'important'
    };
  }

  if (eventName == 'DesktopVideo') {
    return {
      key  : gettext('Контент'),
      val  : '<a class="btn" target="_new" href="/remote/?play=' + fact['agent_attachedfile.guid'] + '">' + gettext(
        'Play') + '</a>',
      fdim : 'agent_attachedfile@file_name:file_name',
      fval : fact['agent_attachedfile.file_name'],
      flbl : fact['agent_attachedfile.file_name'],
      class: 'important',
    };
  }

  if (eventName == 'MicRecording' || fact['parentName'] == 'MicRecording') {
    return {
      key  : gettext('Контент'),
      val  : '<sc-audio-file fact="fact" src="\'/media/\' + fact[\'agent_attachedfile.data\']"></sc-audio-file>',
      fdim : 'agent_attachedfile@file_name:file_name',
      fval : fact['agent_attachedfile.file_name'],
      flbl : fact['agent_attachedfile.file_name'],
      class: 'important',
    };
  } else {
    let file_name = escapeHtml(fact['agent_attachedfile.file_name']);
    return {
      key  : gettext('Контент'),
      val  : '<span class="attfilelink">' + gettext('Скачать') +
      ' <a href="/media/' + fact['agent_attachedfile.data'] +
      '" target="_blank" download="' + file_name + '">' + file_name +
      ' <i class="icon icon-download"></i></a></span>',
      fdim : 'agent_attachedfile@file_name:file_name',
      fval : fact['agent_attachedfile.file_name'],
      flbl : fact['agent_attachedfile.file_name'],
      class: 'important',
    };
  }
};
let AttachedFileName = function (fact) {
  return {
    key  : gettext('Имя файла'),
    val  : fact['agent_attachedfile.file_name'],
    fdim : 'agent_attachedfile@file_name:file_name',
    fval : fact['agent_attachedfile.file_name'],
    flbl : fact['agent_attachedfile.file_name'],
    class: 'important',
  };
};
let AttachedFilePath = function (fact) {
  return {
    key  : gettext('Путь'),
    val  : fact['agent_attachedfile.file_path'],
    fdim : 'agent_attachedfile@file_path:file_path',
    fval : fact['agent_attachedfile.file_path'],
    flbl : fact['agent_attachedfile.file_path'],
    class: 'important',
  };
};
let SenderProperty = function (fact) {
  let sender = fact['agent_dialog.sender'];
  return {
    key : gettext('Отправитель'),
    val : escapeHtml(sender),
    fdim: 'agent_dialog@sender:sender',
    fval: sender,
    flbl: sender,
  };
};
let RecipientsProperty = function (fact) {
  let recipients = fact['agent_dialog.recipients'];
  return {
    key : gettext('Получатели'),
    val : escapeHtml(recipients),
    fdim: 'agent_dialog@recipients:recipients',
    fval: recipients,
    flbl: recipients,
  };
};
let MembersProperty = function (fact) {
  let members = fact['agent_dialog.members'];
  let sender = fact['agent_dialog.sender'];
  let recipients = fact['agent_dialog.recipients'];
  return {
    key  : gettext('Участники'),
    val  : escapeHtml(sender) + ' ➤ ' + escapeHtml(recipients),
    fdim : 'agent_dialog@members:members',
    fval : members,
    flbl : members,
    class: 'important',
  };
};
let NetworkConnectionProperty = function (fact) {
  let remote_address = fact['agent_networkconnection.remote_address'];
  let remote_port = fact['agent_networkconnection.remote_port'];
  return {
    key  : gettext('Сетевая активность'),
    val  : remote_address + ':' + remote_port,
    fdim : 'agent_networkconnection@remote_address:remote_address',
    fval : remote_address,
    flbl : remote_address,
    class: 'important',
  };
};
let CallDurationProperty = function (fact) {
  return {
    key  : gettext('Длительность'),
    val  : fact['call_duration'],
    class: 'important',
  };
};
let MessageFormatProperty = function (fact) {
  return {
    key: gettext('Формат'),
    val: fact['agent_dialog.message_format'],
  };
};
let fixedString = function (s, wl) {
  let l = s.length;
  return l > wl + 5 ? s.slice(0, wl / 2) + '.. ..' + s.slice(l - wl / 2, l) : s;
};
let TextProperty = function (fact) {
  let eventName = fact['agent_eventtype.name'];
  let textData = fact['text_data'];
  let sval;
  if (eventName === 'FileOperation') {
//         textData.split('\n')
    let wl = 40;
    sval = textData.split('\n').reduce(function (a, b, c) {
      return a + ( (c == 0 && textData.indexOf('\n') != -1) ?
          '<b>' + gettext('Из') + '</b> ' : '' ) +
        ( c === 1 ? '<b>' + gettext('В') + '</b> ' : '' ) + fixedString(
          b,
          wl,
        ) + ( c === 0 ? ' ' : '' );
    }, '');
    textData = textData.split('\n').reduce(function (a, b, c) {
      return a + ( (c == 0 && textData.indexOf('\n') != -1) ?
          '<b>' + gettext('Из') + '</b> ' : '' ) +
        ( c === 1 ? '<b>' + gettext('В') + '</b> ' : '' ) + b + ( c === 0 ? ' ' : '' );
    }, '');
  } else {
    sval = textData;
  }
  return {
    key  : fact['agent_eventtype.description'],
    val  : textData,
    sval : sval,
    class: 'important',
  };
};
let WebProperty = function (fact) {
  let url = fact['agent_web.url'];
  if (url === null || url === undefined) {
    return '';
  }
  return {
    key  : gettext('Посещение сайта'),
    val  : escapeHtml(url),
    fdim : 'agent_web@url:url',
    fval : url,
    flbl : url,
    class: 'details',
  };
};
let SiteProperty = function (fact) {
  let domain = fact['agent_web.site'];
  if (domain === null || domain === undefined) {
    return '';
  }
  return {
    key  : gettext('Домен'),
    val  : escapeHtml(domain),
    fdim : 'agent_web@site:site',
    fval : domain,
    flbl : domain,
    class: 'details',
  };
};
let DomainProperty = function (fact) {
  let domain = fact['agent_web.domain'];
  if (domain === null || domain === undefined) {
    return '';
  }
  return {
    key  : gettext('Site'),
    val  : escapeHtml(domain),
    fdim : 'agent_web@domain:domain',
    fval : domain,
    flbl : domain,
    class: 'details',
  };
};
let TypeProperty = function (fact) {
  let eventName = fact['agent_eventtype.name'];
  let propClass = 'details';
  if (eventName === 'Stat') {
    propClass = 'important';
  }
  return {
    key  : gettext('Тип события'),
    val  : fact['agent_eventtype.description'],
    fdim : 'agent_eventtype@default:agent_eventtype',
    fval : fact['agent_eventtype.id'],
    flbl : fact['agent_eventtype.description'],
    class: propClass,
    icon : TYPE2CLASS[fact['agent_eventtype.name']],
  };
};

let InstallationProductProperty = function (fact) {
  return {
    key  : gettext('Продукт'),
    val  : escapeHtml(fact['agent_appinstallation.product_name'] || ''),
    fdim : 'agent_appinstallation@product_name:product_name',
    fval : fact['agent_appinstallation.product_name'],
    flbl : fact['agent_appinstallation.product_name'],
    class: 'important',
  };
};
let InstallationEventProperty = function (fact) {
  return {
    key  : gettext('Операция'),
    val  : AppInstallationEvents[fact['agent_appinstallation.install_event']],
    fdim : 'agent_appinstallation@install_event:install_event',
    fval : fact['agent_appinstallation.install_event'],
    flbl : fact['agent_appinstallation.install_event'],
    class: 'important',
  };
};
let FileOperationProperty = function (fact) {
  return {
    key  : gettext('Операция'),
    val  : fact['agent_attachedfile.file_operation'],
    fdim : 'agent_attachedfile@file_operation:file_operation',
    fval : fact['agent_attachedfile.file_operation'],
    flbl : fact['agent_attachedfile.file_operation'],
    class: 'important',
  };
};
let LogonProperty = function (fact) {
  return {
    key  : gettext('Действие'),
    val  : UserLogonEvents[fact['logon_event']],
    fdim : 'logon_event@default:logon_event',
    fval : fact['logon_event'],
    flbl : UserLogonEvents[fact['logon_event']],
    class: 'important',
    icon : TYPE2CLASS[fact['logon_event']],
  };
};
let WindowTitleProperty = function (fact) {
  return {
    key  : gettext('Заголовок окна'),
    val  : fact['window_title'],
    fdim : '',
    fval : '',
    flbl : '',
//     fdim : 'keyword',
//     fval : fact['window_title'],
//     flbl : fact['window_title'],
    class: 'window-title',
  };
};
let ComputerProperty = function (fact) {
  return {
    key : gettext('Агент'),
    val : fact['agent_agent.computer_name'],
    fdim: 'agent_agent@computer_name:computer_name',
    fval: fact['agent_agent.id'],
    flbl: fact['agent_agent.computer_name'],
  };
};
let AccountProperty = function (fact) {
  return {
    key : gettext('Пользователь'),
    val : fact['agent_account.user_name'],
    fdim: 'agent_account@user_name:user_name',
    fval: fact['agent_account.user_name'],
    flbl: fact['agent_account.user_name'],
  };
};
let DeviceManufacturerProperty = function (fact) {
  return {
    key  : gettext('Тип устройства'),
    val  : fact['agent_device.manufacturer'],
    fdim : 'agent_device@manufacturer:manufacturer',
    fval : fact['agent_device.manufacturer'],
    flbl : fact['agent_device.manufacturer'],
    class: 'important',
  };
};
let DeviceDescriptionProperty = function (fact) {
  return {
    key : gettext('Устройство'),
    val : fact['agent_device.description'],
    fdim: 'agent_device@description:description',
    fval: fact['agent_device.description'],
    flbl: fact['agent_device.description'],
  };
};
let DeviceHWIDProperty = function (fact) {
  return {
    key : gettext('HardwareId'),
    val : fact['agent_device.hwid'],
    fdim: 'agent_device@hwid:hwid',
    fval: fact['agent_device.hwid'],
    flbl: fact['agent_device.hwid'],
  };
};
let DriveTypeProperty = function (fact) {
  return {
    key : gettext('Тип диска'),
    val : fact['agent_device.drive_type'],
    fdim: 'agent_device@drive_type:drive_type',
    fval: fact['agent_device.drive_type'],
    flbl: fact['agent_device.drive_type'],
  };
};
let FeedbackProperty = function (fact) {
  return {
    key : gettext('Статус'),
    val : fact['agent_feedbacktype.name'],
    fdim: 'agent_feedbacktype@default:agent_feedbacktype',
    fval: fact['agent_feedbacktype.id'],
    flbl: fact['agent_feedbacktype.name'],
  };
};
let ParentProperty = function (fact) {
  return {
    key : gettext('Источник'),
    val : fact['parent.event_type_name'] + ' <i class="icon-login"></i>',
    fdim: 'id@default:id',
    fval: fact['parent_id'],
    flbl: fact['parent_id'],
  };
};
let ChildrenProperty = function (fact) {
  return {
    key : gettext('Источник'),
    val : fact['agent_eventtype.name'] + ' <i class="icon-login"></i>',
    fdim: 'id@default:id',
    fval: fact['id'],
    flbl: fact['id'],
  };
};
let TriggeredFilterProperty = function (fact) {
  let value_value = fact['analytics_filter.name'] ? fact['analytics_filter.name'] : gettext(
    'Все события');
  return {
    key  : gettext('Фильтр'),
    val  : value_value,
    fdim : 'analytics_filter@name:name',
    fval : value_value,
    flbl : value_value,
    class: 'important',
  };
};
let CommentProperty = function (fact) {
  let val = fact['text_data'] + ' ' + fact['agent_account.comment'];
  return {
    key  : gettext('Комментарий'),
    val  : val,
    class: 'important',
  };
};

let ATTR2PROP = {
  'analytics_filter.name'                 : TriggeredFilterProperty,
  'agent_feedbacktype.name'               : FeedbackProperty,
  'agent_eventtype.description'           : TypeProperty,
  'agent_agent.computer_name'             : ComputerProperty,
  'agent_account.user_name'               : AccountProperty,
  'agent_attachedfile.data'               : AttachedFileProperty,
  'agent_attachedfile.file_name'          : AttachedFileName,
  'agent_attachedfile.file_path'          : AttachedFilePath,
  'agent_attachedfile.file_operation'     : FileOperationProperty,
  'agent_networkconnection.remote_address': NetworkConnectionProperty,
  'agent_dialog.sender'                   : SenderProperty,
  'agent_dialog.recipients'               : RecipientsProperty,
  'agent_dialog.members'                  : MembersProperty,
  'call_duration'                         : CallDurationProperty,
  'text_data'                             : TextProperty,
  'agent_dialog.message_format'           : MessageFormatProperty,
  'agent_web.url'                         : WebProperty,
  'agent_web.site'                        : SiteProperty,
  'agent_web.domain'                      : DomainProperty,
  'logon_event'                           : LogonProperty,
  'agent_appinstallation.install_event'   : InstallationEventProperty,
  'agent_appinstallation.product_name'    : InstallationProductProperty,
  'window_title'                          : WindowTitleProperty,
  'agent_device.manufacturer'             : DeviceManufacturerProperty,
  'agent_device.description'              : DeviceDescriptionProperty,
  'agent_device.hwid'                     : DeviceHWIDProperty,
  'agent_device.drive_type'               : DriveTypeProperty,
  'parent_id'                             : ParentProperty,
  'children_id'                             : ChildrenProperty,
};

let IMPATTR2PROP = [
  'analytics_filter.name',
  'window_title',
  'agent_attachedfile.file_operation',
  'agent_attachedfile.file_name',
  'agent_attachedfile.data',
  'agent_networkconnection.remote_address',
  'agent_dialog.sender',
//   'call_duration',
  'text_data',
//   'agent_dialog.message_format',
//   'agent_web.url',
  'logon_event',
  'agent_appinstallation.install_event',
  'agent_appinstallation.product_name',
  'agent_device.drive_type',
  'agent_device.description',
  'parent_id',
];

/////////////////////
// For Table View !!!

let dateFiler = (x,y) => x.toString().replace('T',' ').substring(0,19);

// Build Icon
let makeIcon = function (icon) {
  if (icon && icon[0] == '/') {
    icon = '<img class="widget-icon" src="' + icon + '"/>';
  }
  else if (icon) {
    icon = icon + ' widget-icon';
    icon = icon && '<span class="' + icon + '"></span>';
  } else {
    icon = '';
  }
  return icon;
};
// Build filter attrs
let makeFilterAttrs = function (dimension, dim_key, dim_label) {
  let filterAttrs = '';
  if (dimension) {
    let fdim = dimension;
    let fval = dim_key != undefined ? dim_key : '';
    let flbl = dim_label ? dim_label : '';
    filterAttrs = ' class="widget-filter" data-key="' + fdim + '" data-value="' + fval + '" data-label="' + flbl + '"';
  } else {
    filterAttrs = ' class="widget-data"';
  }
  return filterAttrs;
};

// Build cell from property
let cellFromProp = function (prop, mode) {
  if (!prop) return '';
  let icon = makeIcon(prop.icon);
  if (mode === 'extended') {
    return '<span' + makeFilterAttrs(
        prop.fdim,
        prop.fval,
        escapeHtml(prop.flbl),
      ) + ' ng-bind-html="trustAsHtml(textData)"></span>';
  }
  let valueText = ( (mode === 'short' && prop.sval) ? prop.sval : prop.val) || '';
  return '<span' + makeFilterAttrs(
      prop.fdim,
      prop.fval,
      escapeHtml(prop.flbl),
    ) + '>' + icon + ' ' + valueText + '</span>';
};

export function buildWidget(fact) {
  if (!fact) return;
  // Build widget from property
  let widgetFromProp = function (prop) {
    if (!prop) return '';
    let icon = makeIcon(prop.icon);
    let prop_class = prop.class ? prop.class : 'details';
    return '\
            <div class="row-fluid widget-property ' + prop_class + '">\
                <div class="span4 widget-key"><span class="label label-info">' + prop.key + ':</span></div>\
                <div class="span8 widget-value">' + icon + '<span' + makeFilterAttrs(
        prop.fdim,
        prop.fval,
        escapeHtml(prop.flbl),
      ) + '>' + prop.val + '</span></div>\
            </div>';
  };
  // Event widget start
  let widget = '<div ng-click="collapse()" class="widget-body"><div class="widget-properties">';
  // Build properties
  for (let k in ATTR2PROP) {
    if (fact[k]) {
      widget = widget + widgetFromProp(ATTR2PROP[k](fact));
    }
  }

  if (fact.children) {
    widget = widget + fact.children.map(function (ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        return ch['agent_attachedfile.data'] ?
          widgetFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) : '';
      }).join('');
  }

  widget = widget + '</div>';
  widget = widget + '<div class="widget-important">';
  // Collapse button
  widget = widget + '<div class="widget-menu"><i ng-class="{\'icon-collapse\': isCollapsed, \'icon-uncollapse\': !isCollapsed}"></i></div>';
  // Local time
  widget = widget + '<div class="widget-time">' +
    dateFiler(fact['local_time'], 'yyyy-MM-dd HH:mm:ss') + '</div>';
  // Application
  if (fact['agent_application.app_name']) {
    let app_icon = makeIcon('/analytics/icon/' + fact['agent_application.app_icon_id']);
    let app_name = fact['agent_application.app_name'];
    widget = widget + '<div class="widget-app">' + app_icon +
      '<span' + makeFilterAttrs('agent_application@app_name:app_name',
        app_name, app_name,
      ) + '>' + app_name + '</span></div>';
  }
  widget = widget + '</div><div class="clearfix"/></div>';
  return widget;
}

////////////////////////////////////////////////////////////////////////////
// Build data
let TimeCol = {
  'label': gettext('Время'), 'cssClass': 'fact-time',
  'parse': function (fact) {
    return dateFiler(fact['local_time'], 'yyyy-MM-dd HH:mm:ss');
  },
  sortable: true,
};
let TypeCol = {
  'label': gettext('Тип'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_eventtype.description'](fact));
  },
  'dim'  : 'agent_eventtype@default:agent_eventtype',
};
let ComputerCol = {
  'label': gettext('Компьютер'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_agent.computer_name'](fact));
  },
  'dim'  : 'agent_agent@computer_name:computer_name',
};
let OwnerCol = {
  'label': gettext('Владелец'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_agent.computer_name'](fact));
  },
  'dim'  : 'agent_agent@computer_name:computer_name',
};
let UserCol = {
  'label': gettext('Пользователь'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_account.user_name'](fact));
  },
  'dim'  : 'agent_account@user_name:user_name',
};
let WebCol = {
  'label': gettext('Ссылка'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_web.url'](fact));
  },
};
let SiteCol = {
  'label': gettext('Домен'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_web.site'](fact));
  },
};
let DomainCol = {
  'label': gettext('Сайт'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_web.domain'](fact));
  },
};
let AppCol = {
  'label': gettext('Приложение'),
  'parse': function (fact) {
    let app_icon = makeIcon('/analytics/icon/' + fact['agent_application.app_icon_id']);
    let app_name = fact['agent_application.app_name'];
    return app_name ? '<span' +
      makeFilterAttrs(
        'agent_application@app_name:app_name',
        app_name,
        app_name,
      ) +
      '>' + app_icon + app_name + '</span>': '';
  },
  'dim'  : 'agent_application@app_name:app_name',
};
let TitleCol = {
  'label': gettext('Заголовок'), 'cssClass': 'fact-wide',
  'parse': function (fact) {
    return fact['window_title'] ? cellFromProp(ATTR2PROP['window_title'](fact)): '';
  },
};
let FileOperationTypeCol = {
  'label': gettext('Операция'),
  'parse': function (fact) {
    return fact['agent_attachedfile.file_operation'] ?
      cellFromProp(ATTR2PROP['agent_attachedfile.file_operation'](fact)) : '';
  },
};
let FileOperationCol = {
  'label': gettext('Описание'),
  'parse': function (fact) {
    return !fact['agent_attachedfile.file_path'] || fact['text_data'] && fact['text_data'].indexOf('\n') != -1 ? cellFromProp(ATTR2PROP['text_data'](fact)) : '';
  },
};
let ExtraCol = {
  'label': gettext('Дополнительно'),
  'parse': function (fact) {
    return fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact)): '';
  },
};
let TextCol = {
  'label': gettext('Текст'), 'cssClass': 'fact-wide',
  'parse': function (fact, mode) {
    return fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact), mode): '';
  },
};
let KeyboardTextCol = {
  'label': gettext('Текст'), 'cssClass': 'fact-wide',
  'parse': function (fact, mode) {
    return cellFromProp(ATTR2PROP['text_data'](fact, mode));
  },
};
let NetCol = {
  'label': gettext('Сокет'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_networkconnection.remote_address'](fact));
  },
};
let SenderCol = {
  'label': gettext('Отправитель'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_dialog.sender'](fact));
  },
};
let RecipientsCol = {
  'label': gettext('Получатели'),
  'parse': function (fact) {
    return fact['agent_dialog.recipients'] ?
      cellFromProp(ATTR2PROP['agent_dialog.recipients'](fact)) : '';
  },
};
let ImMessageCol = {
  'label': gettext('Сообщение'), 'cssClass': 'fact-wide',
  'parse': function (fact, mode) {
    return cellFromProp(ATTR2PROP['text_data'](fact), mode);
  },
};
let InstallEventCol = {
  'label': gettext('Операция'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_appinstallation.install_event'](fact));
  },
  'dim'  : 'agent_appinstallation@install_event:install_event',
};
let InstallProductCol = {
  'label': gettext('Продукт'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_appinstallation.product_name'](fact));
  },
  'dim'  : 'agent_appinstallation@product_name:product_name',
};
let AttachedFileNameCol = {
  'label': gettext('Имя файла'),
  'parse': function (fact) {
    return fact['agent_attachedfile.file_name'] ?
      cellFromProp(ATTR2PROP['agent_attachedfile.file_name'](fact)) : '';
  },
};
let AttachedFilePathCol = {
  'label': gettext('Путь'),
  'parse': function (fact) {
    return fact['agent_attachedfile.file_path'] ?
      cellFromProp(ATTR2PROP['agent_attachedfile.file_path'](fact)) : '';
  },
};
let AttachedFileCol = {
  'label': gettext('Контент'), 'cssClass': 'fact-wide',
  'parse': function (fact) {
    if (fact['agent_attachedfile.data']) {
      return cellFromProp(ATTR2PROP['agent_attachedfile.data'](fact));
    }
    if (fact.children) {
      return fact.children.map(function (ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        let linkToChildren = ch['id'] ? cellFromProp(ATTR2PROP['children_id'](ch)) : '';
        return ch['agent_attachedfile.data'] ?
          cellFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) + linkToChildren : '';
      }).join('');
    }
    return '';
  },
};
let ScreenshotCol = {
  'label': gettext('Снимок'), 'cssClass': 'fact-wide',
  'parse': function (fact) {
    if (fact['agent_attachedfile.data']) {
      return cellFromProp(ATTR2PROP['agent_attachedfile.data'](fact));
    }
    if (fact.children) {
      return fact.children.map(function (ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        return ch['agent_attachedfile.data'] ?
          cellFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) : '';
      }).join('');
    }
    return '';
  },
};
let DeviceManufacturerCol = {
  'label': gettext('Тип'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_device.manufacturer'](fact));
  },
};
let DeviceDescriptionCol = {
  'label': gettext('Устройство'),
  'parse': function (fact) {
    return fact['agent_device.description'] ?
      cellFromProp(ATTR2PROP['agent_device.description'](fact)) : '';
  },
};
let DeviceHWIDCol = {
  'label': gettext('ID'),
  'parse': function (fact) {
    return fact['agent_device.hwid'] ?
      cellFromProp(ATTR2PROP['agent_device.hwid'](fact)) : '';
  },
};
let DriveTypeCol = {
  'label': gettext('Тип диска'),
  'parse': function (fact) {
    return fact['agent_device.drive_type'] ?
      cellFromProp(ATTR2PROP['agent_device.drive_type'](fact)) : '';
  },
};
let LogonCol = {
  'label': gettext('Событие'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['logon_event'](fact));
  },
  'dim'  : 'logon_event@default:logon_event',
};
let AmountCol = {
  'label': gettext('Количество'),
  'parse': function (fact) {
    return fact['call_duration'];
  },
};
let PriceCol = {
  'label': gettext('Цена'),
  'parse': function (fact) {
    return fact['activity_time'];
  },
};
let TotalPagesCol = {
  'label': gettext('Страницы'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['call_duration'](fact));
  },
};
let EventCol = {
  'label': gettext('Событие'), 'cssClass': 'fact-wide',
  'parse': function (fact) {
    let w = IMPATTR2PROP.map(function (attr) {
      return fact[attr] ? cellFromProp(ATTR2PROP[attr](fact)) : '';
    }).join('');
    fact.children ?
      fact.children.forEach(function (ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        w = w + IMPATTR2PROP.map(function (attr) {
            return ch[attr] ? cellFromProp(ATTR2PROP[attr](ch)) : '';
          }).join('');
      }) : null;
    return w;
  },
};
let UserActiveCol = {
  'label': gettext('Длительность'),
  'parse': function (fact) {
    return ticksFormat(fact['activity_time']);
  },
};
let FeedbackCol = {
  'label': gettext('Статус'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_feedbacktype.name'](fact));
  },
};
let BacklinkCol = {
  'label': gettext('Ссылка'),
  'parse': function (fact) {
    return '<a href=\'' + DEFAULT_FEEDBACK_URL +
      fact['window_title'] + '\' target=\'_new\'>' +
      fact['window_title'] + '</a>';
  },
};
let CommentCol = {
  'label': gettext('Комментарий'),
  'parse': function (fact) {
    return cellFromProp(ATTR2PROP['agent_account.comment'](fact));
  },
};
let ParentCol = {
  'label': gettext('Связано с'),
  'parse': function (fact) {
    return fact['parent_id'] ? cellFromProp(ATTR2PROP['parent_id'](fact)): '';
  },
};

// TableViews
let tableViews = [
  {
    'name'     : 'BaseTable',
    'columns'  : [TimeCol, TypeCol, ComputerCol, UserCol, AppCol, EventCol],
    'important': [EventCol],
    'colwidths': [.1, .1, .1, .1, .1, .5],
  }, {
    'name'     : 'Keyboard',
    'columns'  : [TimeCol, ComputerCol, UserCol, AppCol, TitleCol, TextCol],
    'important': [AppCol, TitleCol, WebCol, KeyboardTextCol],
  }, {
    'name'     : 'AppRun',
    'columns'  : [TimeCol, ComputerCol, UserCol, AppCol],
    'important': [AppCol, TitleCol],
  }, {
    'name'     : 'AppActiv',
    'columns'  : [TimeCol, ComputerCol, UserCol, AppCol, TitleCol],
    'important': [AppCol, TitleCol, TextCol, DomainCol, WebCol],
  }, {
    'name'     : 'Screenshot',
    'columns'  : [TimeCol, ComputerCol, UserCol, TitleCol, ScreenshotCol],
    'important': [AppCol, TitleCol, WebCol, ScreenshotCol],
  }, {
    'name'     : 'WebcamSnapshot',
    'columns'  : [TimeCol, ComputerCol, UserCol, AppCol, ScreenshotCol],
    'important': [UserCol, ScreenshotCol],
  }, {
    'name'     : 'MicRecording',
    'columns'  : [
      TimeCol, ComputerCol, UserCol,
      DeviceDescriptionCol, AttachedFileCol,
    ],
    'important': [DeviceDescriptionCol, AttachedFileCol],
  }, {
    'name'     : 'Net',
    'columns'  : [TimeCol, ComputerCol, UserCol, AppCol, NetCol],
    'important': [NetCol, AppCol],
  }, {
    'name'     : 'Install',
    'columns'  : [
      TimeCol, ComputerCol, UserCol,
      InstallEventCol, InstallProductCol,
    ],
    'important': [InstallEventCol, InstallProductCol],
  }, {
    'name'     : 'Web',
    'columns'  : [TimeCol, ComputerCol, UserCol, AppCol, DomainCol, TitleCol],
    'important': [AppCol, DomainCol, TitleCol, WebCol],
    'colwidths': [.1, .1, .1, .1, .1, .3],
  }, {
    'name'     : 'Im',
    'columns'  : [
      TimeCol, ComputerCol, UserCol, SenderCol,
      RecipientsCol, ImMessageCol, AttachedFileCol,
    ],
    'important': [
      SenderCol, RecipientsCol,
      TitleCol, AttachedFileCol, ImMessageCol,
    ],
    'colwidths': [.1, .1, .1, .1, .1, .4, .1],
  }, {
    'name'     : 'Mail',
    'columns'  : [
      TimeCol, ComputerCol, UserCol, SenderCol,
      RecipientsCol, TitleCol, AttachedFileCol,
    ],
    'important': [
      SenderCol, RecipientsCol, TitleCol,
      AttachedFileCol, ImMessageCol,
    ],
    'colwidths': [.1, .1, .1, .1, .1, .4, .1],
  }, {
    'name'     : 'PrintDoc',
    'columns'  : [
      TimeCol, ComputerCol, UserCol, TotalPagesCol,
      TextCol, AttachedFileCol,
    ],
    'important': [TextCol, AttachedFileCol, TotalPagesCol],
    'colwidths': [.1, .1, .1, .1, .3, .3],
  }, {
    'name'     : 'Clipboard',
    'columns'  : [
      TimeCol, ComputerCol, UserCol,
      AppCol, TextCol, AttachedFileCol,
    ],
    'important': [TextCol, AttachedFileCol],
  }, {
    'name'     : 'Logon',
    'columns'  : [TimeCol, ComputerCol, UserCol, LogonCol],
    'important': [LogonCol],
  }, {
    'name'     : 'Device',
    'columns'  : [
      TimeCol, ComputerCol, UserCol, DeviceManufacturerCol,
      DeviceDescriptionCol, DeviceHWIDCol, ExtraCol,
    ],
    'important': [
      DeviceManufacturerCol, DeviceDescriptionCol,
      DeviceHWIDCol, ExtraCol,
    ],
  }, {
    'name'     : 'DevInventory',
    'columns'  : [
      TimeCol, ComputerCol, UserCol, DeviceManufacturerCol,
      DeviceDescriptionCol, DeviceHWIDCol, ExtraCol,
    ],
    'important': [
      DeviceManufacturerCol, DeviceDescriptionCol,
      DeviceHWIDCol, ExtraCol,
    ],
  }, {
    'name'     : 'FileOperation',
    'columns'  : [
      TimeCol, ComputerCol, UserCol, AppCol, FileOperationTypeCol, AttachedFileNameCol, DeviceDescriptionCol, DriveTypeCol
    ],
    'important': [
      FileOperationTypeCol, AttachedFileNameCol, AttachedFilePathCol, DeviceDescriptionCol, DriveTypeCol, FileOperationCol, ParentCol
    ],
  }, {
    'name'     : 'Stat',
    'columns'  : [ TimeCol, TypeCol, ComputerCol, UserCol, UserActiveCol, AppCol, DomainCol, TitleCol ],
    'important': [AppCol, TitleCol, DomainCol, WebCol, UserActiveCol],
    'colwidths': [.1, .1, .1, .1, .1, .1, .1, .3]
  }, {
    'name'     : 'UserFeedback',
    'columns'  : [
      BacklinkCol, TimeCol, FeedbackCol, OwnerCol,
      UserCol, AmountCol, PriceCol, CommentCol,
    ],
    'important': [
      BacklinkCol, TimeCol, FeedbackCol, OwnerCol,
      UserCol, AmountCol, PriceCol, CommentCol,
    ],
  }, {
    'name'     : 'AttachedFile',
    'columns'  : [
      TimeCol, ComputerCol, UserCol, AppCol,
      AttachedFileCol, ParentCol, RecipientsCol,
    ],
    'important': [
      AttachedFileCol, ParentCol, RecipientsCol,
      FileOperationTypeCol, DeviceDescriptionCol, AttachedFileNameCol,
      AttachedFilePathCol, TextCol, DriveTypeCol,
    ],
  }, {
    'name'     : 'SystemLog',
    'columns'  : [TimeCol, TypeCol, ComputerCol, AppCol, TextCol, AttachedFileCol],
    'important': [AppCol, TextCol, AttachedFileCol],
  }, {
    'name'     : 'FrameBuffer',
    'columns'  : [TimeCol, ComputerCol, UserCol, AttachedFileCol],
    'important': [AttachedFileCol],
  }, {
    'name'     : 'SearchQuery',
    'columns'  : [TimeCol, ComputerCol, UserCol, AppCol, SiteCol, TextCol],
    'important': [AppCol, SiteCol, TextCol, WebCol],
  },
];

let tableViewByType = {
  '0'     : 'AttachedFile',
  '1'     : 'Keyboard',
  '2'     : 'AppRun',
  '3'     : 'AppActiv',
  '4'     : 'Screenshot',
  '5'     : 'Net',
  '6'     : 'Install',
  '7'     : 'Web',
  '8'     : 'Im',
  '9'     : 'Mail',
  '11'    : 'PrintDoc',
  '12'    : 'Logon',
  '13'    : 'Clipboard',
  '14'    : 'Device',
  '15'    : 'Device',
  '16'    : 'FileOperation',
  '17'    : 'SystemLog',
  '18'    : 'Stat',
  '19'    : 'UserFeedback',
  '20'    : 'WebcamSnapshot',
  '21'    : 'MicRecording',
  '22'    : 'FrameBuffer',
  '23'    : 'DevInventory',
  '24'    : 'Install',
  '25'    : 'SearchQuery',
  '100500': 'Stat',
};

export function getTableViewByType(eventTypeId, filters) {
  let viewTypeName = tableViewByType[eventTypeId] ?
    tableViewByType[eventTypeId] : 'BaseTable';
  let tableView = $.grep(tableViews, tv => tv.name === viewTypeName)[0];
  if (filters) {
    let skipCols = filters.reduce((p, f) => {
      if (f.dimension === 'agent_eventtype@default:agent_eventtype') {
        return p;
      }
      if (f.predicates && f.predicates.length) {
        return p;
      }
      p = p.concat(tableView.columns.filter(c =>
        c.dim === f.dimension && filters.reduce((c, cf) =>
        c + (f.dimension === cf.dimension ? 1 : 0), 0) === 1,
      ));
      return p;
    }, []);

    if (skipCols.length > 0) {
      let replaceTableView = {
        'name'     : tableView.name,
        'columns'  : tableView.columns.map(c => c),
        'important': tableView.important,
        'colwidths': tableView.colwidths ?
          tableView.colwidths.map(c => c) : undefined,
      };
      for (let s in skipCols) {
        let i = replaceTableView.columns.indexOf(skipCols[s]);
        replaceTableView.columns.splice(i, 1);
        if (replaceTableView.colwidths) {
          replaceTableView.colwidths.splice(i, 1);
        }
      }
      return replaceTableView;
    }
  }
  return tableView;
}

///////////////////////////



// WEBPACK FOOTER //
// ./src/facts/table-view.js